import { render, staticRenderFns } from "./ProcurementChat.vue?vue&type=template&id=111355bd&scoped=true"
import script from "./ProcurementChat.vue?vue&type=script&lang=js"
export * from "./ProcurementChat.vue?vue&type=script&lang=js"
import style0 from "./ProcurementChat.vue?vue&type=style&index=0&id=111355bd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111355bd",
  null
  
)

export default component.exports